module.exports = __webpack_public_path__ + "img/ble.dff99b97.png";